module.exports = __webpack_public_path__ + "static/media/perfilgithub.59a882d5.jpg";